export default "__VITE_ASSET__BsmlVrvS__"